export function vibrate(length: any) {
  return function decorator(_target: any, _key: any, descriptor: any) {
    const origFn = descriptor.value;

    descriptor.value = async function decorated(...args: any[]) {
      if ('vibrate' in navigator) {
        navigator.vibrate(length);
      }
      await origFn.call(this, ...args);
    };
    return descriptor;
  };
}
